export const FIRST_MILE = "fm";
export const MITCHELL = "m1";
export const ROWRITER = "row";

export const EXPERIENCES = [FIRST_MILE, MITCHELL, ROWRITER];
